import React, { useContext, useEffect } from "react";

import PostItem from "./PostItem";
import PostContext from "../../context/post/postContext";
import AlertContext from "../../context/alert/alertContext";

import Grid from '@mui/material/Grid2';
import { Fragment } from "react";
import PostFilter from "./PostFilter";

const Posts = ({ tags }) => {
  const postContext = useContext(PostContext);
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;

  const { posts, getPosts, loading, message, clearPostMessages } = postContext;

  useEffect(() => {
    getPosts(tags);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (message === "add_post_success") {
      setAlert("New memory successfully created", "success");
      clearPostMessages();
    } else if (message === "delete_post_success") {
      setAlert("Memory successfully deleted", "success");
      clearPostMessages();
    }
    // eslint-disable-next-line
  }, [message]);

  if (posts !== null && posts.length === 0 && !loading) {
    return (
      <Fragment>
        <PostFilter tags={tags} />
        <h4>No post to show</h4>
      </Fragment>
    );
  }

  return (
    <Grid container spacing={4}>
      <PostFilter tags={tags} />
      {posts !== null && !loading ? (
        posts.map((post) => <PostItem key={post.id} post={post} />)
      ) : (
        <div className="preloader-wrapper big active">
          <div className="spinner-layer spinner-blue-only">
            <div className="circle-clipper left">
              <div className="circle"></div>
            </div>
            <div className="gap-patch">
              <div className="circle"></div>
            </div>
            <div className="circle-clipper right">
              <div className="circle"></div>
            </div>
          </div>
        </div>
      )}
    </Grid>
  );
};

export default Posts;
